import React, { useContext, useEffect, useState } from 'react';
import {
    CustomerWorkoutSetCreatUpdate,
    resetCustomerWorkoutSetFormValue,
    resetSetItem,
    SelectableExercise,
    setContext,
    setCustomerWorkoutSetFormValue,
    setSelectableExercises,
    setSelectedExercise,
    setSelectedGroup,
    setSetItem,
    setWorkoutSetItems,
} from '../state/customer.slice';
import { CustomerWorkoutCreateSetFormData } from '../beans/customer.workout.set.create.form.data';
import { IntlContext } from 'react-intl';
import Select from 'react-select';
import { reactSelectStyles, reactSelectComponents } from 'src/features/_shared/styles/react-select.styles';
import { ContextEnum } from 'src/_shared/enums/context.enum';
import { ExerciseManager } from 'src/_shared/managers/exercise.manager';
import { FormManager } from 'src/_shared/managers/form.manager';
import { QueueManager, QueueKeyType } from 'src/_shared/managers/queue.manager';
import { WorkoutSetManager } from 'src/_shared/managers/workout.set.manager';
import { store } from 'src/_shared/store/configure';
import { useStoreSelector } from 'src/_shared/store/hook';
import { FormHelperUtil } from 'src/_shared/utils/form.helper.util';
import {
    User,
    Workout,
    SessionSet,
    SetCreateRequest,
    DashboardSessionSummaryExercise,
    DashboardSessionSummary,
    DashboardSessionSummaryMuscleGroupSet,
    DashboardExerciseSummary,
    DashboardSessionExerciseSummaryRequest,
    DashboardWorkoutExerciseSummaryRequest,
    ExerciseCreateRequestGroupEnum,
} from 'src/api/entities';
import { TextField } from 'src/features/_shared/components/TextField';
import { muscleGroups, SelectableExerciseGroup } from 'src/features/exercise/utils/muscleGroups';
import { Button } from 'src/features/_shared/components/Button/button.component';
import { setWorkoutSummary } from 'src/features/workout/store/workout.session.slice';
import { DashboardManager } from 'src/_shared/managers/dashboard.manager';
import { setDashboardSessionExerciseSummary, setDashboardWorkoutExerciseSummary } from '../state/customer.analysis.slice';
import { PageTransition } from 'src/features/_shared/components/PageTransition/page.transition.component';
import { ExerciseCreateUpdate, resetExerciseCreate, selectGroup } from 'src/features/exercise/state/exercise.slice';
import { ExerciseFormData } from 'src/features/exercise/beans/exercise.form.data';
import toast, { Toaster } from 'react-hot-toast';
import { Popup } from 'react-leaflet';
import { PopupManager } from 'src/_shared/managers/popup.manager';
import { PopupType } from 'src/features/_shared/components/Popup/popup.item';

export const CustomerWorkoutsCreateView: React.FC = () => {
    const queueManager = QueueManager.getInstance();
    const exerciseManager = ExerciseManager.getInstance();
    const workoutSetManager = WorkoutSetManager.getInstance();
    const dashboardManager = DashboardManager.getInstance();
    const notificationManager = PopupManager.getInstance();

    const customerItem: User = useStoreSelector(state => state.reducer.customerSlice.customer);
    const workoutItem: Workout = useStoreSelector(state => state.reducer.customerSlice.workout);
    const setCreateUpdate: CustomerWorkoutSetCreatUpdate = useStoreSelector(state => state.reducer.customerSlice.setCreateUpdate);
    const selectableExercises: SelectableExercise[] = useStoreSelector(state => state.reducer.customerSlice.selectableExercises);
    const sets: SessionSet[] = useStoreSelector(state => state.reducer.customerSlice.sets);
    const setItem: SessionSet = useStoreSelector(state => state.reducer.customerSlice.setItem);
    const workoutSummaryItem: DashboardSessionSummary = useStoreSelector(state => state.reducer.workoutSessionSlice.workoutSummary);
    const dashboardSessionSummaryExercise: DashboardExerciseSummary[] = useStoreSelector(state => state.reducer.customerAnalysisSlice.dashboardWorkoutExerciseSummary);
    const exerciseFormValues: ExerciseCreateUpdate = useStoreSelector(state => state.reducer.exerciseSlice.exerciseCreate);

    const search = async () => {
        console.log(workoutItem);

        if (workoutItem != undefined) {
            const sets = (await workoutSetManager.search(workoutItem.id!)).data;
            if (sets != undefined) {
                store.dispatch(setWorkoutSetItems({ sets }));
            }
        }
    };

    const searchSetItems = async () => {
        console.log('Searching sets', workoutItem);
        if (workoutItem != undefined) {
            const sets = (await workoutSetManager.search(workoutItem.id!)).data;
            if (sets != undefined) {
                store.dispatch(setWorkoutSetItems({ sets }));
            }
        }
    };
    const getItems = async () => {
        await search();
        const value = await exerciseManager.search(undefined, muscleGroups[0].value);
        store.dispatch(setSelectableExercises({ value }));
        await getWorkoutSummary();
        const request: DashboardWorkoutExerciseSummaryRequest = {
            authorID: customerItem.id!,
            workoutID: workoutItem.id,
        };
        console.log(request);
        console.log(workoutItem);
        console.log(customerItem);
        const dashboardSessionExerciseSummaryResponse = await dashboardManager.getDashboardWorkoutExerciseSummary(request);
        store.dispatch(setDashboardWorkoutExerciseSummary({ dashboardSessionExerciseSummaryResponse }));
    };

    useEffect(() => {
        getItems();
        setSetsCounter(1);
    }, []);

    const intl = useContext(IntlContext);
    const getMessageByFieldAndError = FormHelperUtil.getFormFieldErrorTranslator('wizard.general.data', intl as any);

    const createWorkoutSet = async (request: SetCreateRequest) => {
        await workoutSetManager.create(request), await searchSetItems(), await getWorkoutSummary();
    };

    const handleCreateWorkoutSet = () => {
        for (let i = 0; i < setsCounter; i++) {
            const request: SetCreateRequest = {
                data: {
                    author: {
                        id: customerItem.id,
                        name: customerItem.data?.details?.firstName ?? '',
                    },
                    details: {
                        exercise: {
                            group: setCreateUpdate.exerciseGroup,
                            name: setCreateUpdate.exerciseName,
                            uuid: setCreateUpdate.exerciseUuid,
                        },
                        reps: setCreateUpdate.reps,
                        weight: setCreateUpdate.weight,
                    },
                    session: {
                        id: workoutItem.id!,
                        name: workoutItem.title,
                    },
                },
            };
            queueManager.queue(QueueKeyType.DEFAULT, createWorkoutSet(request));
        }

        store.dispatch(resetCustomerWorkoutSetFormValue());
        setCustomerWorkoutSetCreatUpdateState({
            exerciseGroup: '',
            exerciseName: '',
        });
    };

    const handleSelectGroup = async (group: SelectableExerciseGroup) => {
        const value = await queueManager.queue(QueueKeyType.DEFAULT, exerciseManager.search(undefined, undefined, group.value));
        store.dispatch(setSelectedGroup({ group }));
        store.dispatch(setSelectableExercises({ value }));
        setCustomerWorkoutSetCreatUpdateState({
            exerciseGroup: group.value,
        });
        workoutSetCreateFormData.reset({
            groupExercises: null,
        });
    };

    const handleSelectExercise = (value: SelectableExercise) => {
        console.log(value);
        store.dispatch(setSelectedExercise({ value }));
        setCustomerWorkoutSetCreatUpdateState(prevState => ({
            ...prevState,
            exerciseName: value.value,
            exerciseGroup: customerWorkoutSetCreateState.exerciseGroup,
        }));
        console.log(customerWorkoutSetCreateState);
    };

    const handleDelete = async (uuid: string) => {
        await queueManager.queue(QueueKeyType.DEFAULT, workoutSetManager.delete(uuid));
        await search();
        await getWorkoutSummary();
    };

    const handleDuplicate = async (duplicatingSet: SessionSet) => {
        const workoutSetCreating: SetCreateRequest = {
            data: {
                author: {
                    id: customerItem.id,
                    name: customerItem.data?.details?.firstName ?? '',
                },
                details: {
                    exercise: {
                        group: duplicatingSet.exerciseGroup,
                        name: duplicatingSet.exerciseName,
                        uuid: duplicatingSet.exerciseUuid,
                    },
                    reps: duplicatingSet.reps,
                    weight: duplicatingSet.weight,
                },
                session: {
                    id: duplicatingSet.sessionID,
                    name: duplicatingSet.sessionName,
                },
            },
        };
        queueManager.queue(QueueKeyType.DEFAULT, createWorkoutSet(workoutSetCreating));
        await getItems();
    };

    const handleStartEdit = (value: SessionSet) => {
        store.dispatch(setContext({ value: ContextEnum.UPDATE }));
        store.dispatch(setSetItem({ value }));
        store.dispatch(setCustomerWorkoutSetFormValue({ key: 'exerciseName', value: value.exerciseName! }));
        store.dispatch(setCustomerWorkoutSetFormValue({ key: 'exerciseGroup', value: value.exerciseGroup! }));
        store.dispatch(setCustomerWorkoutSetFormValue({ key: 'exerciseUuid', value: value.exerciseUuid! }));
        store.dispatch(setCustomerWorkoutSetFormValue({ key: 'uuid', value: value.uuid! }));
        store.dispatch(setCustomerWorkoutSetFormValue({ key: 'reps', value: value.reps! }));
        store.dispatch(setCustomerWorkoutSetFormValue({ key: 'weight', value: value.weight! }));
        setCustomerWorkoutSetUpdateState({
            exerciseGroup: value.exerciseGroup,
            exerciseName: value.exerciseName,
        });
        workoutSetCreateFormData.setValue('editWeight', value.weight);
        workoutSetCreateFormData.setValue('editReps', value.reps);
    };

    const handleCancelUpdate = () => {
        store.dispatch(setContext({ value: ContextEnum.CREATE }));
        store.dispatch(resetSetItem());
        setCustomerWorkoutSetUpdateState({
            exerciseGroup: '',
            exerciseName: '',
        });
        workoutSetCreateFormData.setValue('editWeight', '');
        workoutSetCreateFormData.setValue('editReps', '');
        workoutSetCreateFormData.resetField('weight');
        workoutSetCreateFormData.resetField('reps');
        store.dispatch(resetCustomerWorkoutSetFormValue());
    };

    const handleOnBlur = (key: any, value: string) => {
        store.dispatch(setCustomerWorkoutSetFormValue({ key, value }));
    };

    const handleSaveUpdate = async (set: SessionSet) => {
        store.dispatch(setContext({ value: ContextEnum.CREATE }));
        await queueManager.queue(
            QueueKeyType.DEFAULT,
            workoutSetManager.edit(setItem, {
                ...setItem,
                weight: workoutSetCreateFormData.getValues('editWeight'),
                reps: workoutSetCreateFormData.getValues('editReps'),
            }),
        );
        store.dispatch(setContext({ value: ContextEnum.CREATE }));
        store.dispatch(resetSetItem());
        store.dispatch(resetCustomerWorkoutSetFormValue());
        setCustomerWorkoutSetUpdateState({
            exerciseGroup: '',
            exerciseName: '',
        });
        workoutSetCreateFormData.setValue('editWeight', '');
        workoutSetCreateFormData.setValue('editReps', '');
        workoutSetCreateFormData.resetField('weight');
        workoutSetCreateFormData.resetField('reps');
        getItems();
    };

    const workoutSetCreateFormData = FormManager.getInstance().buildFormProxy<CustomerWorkoutCreateSetFormData>(
        CustomerWorkoutCreateSetFormData,
        handleCreateWorkoutSet,
        {
            exerciseName: setCreateUpdate.exerciseName,
            exerciseGroup: setCreateUpdate.exerciseGroup,
            exerciseUuid: setCreateUpdate.exerciseUuid,
            uuid: setCreateUpdate.uuid,
            weight: setCreateUpdate.weight,
            reps: setCreateUpdate.reps,
        },
        'onChange',
    );

    const handleClearWorkoutSet = () => {
        store.dispatch(resetCustomerWorkoutSetFormValue());
        setCustomerWorkoutSetCreatUpdateState({
            exerciseGroup: '',
            exerciseUuid: '',
            exerciseName: '',
        });
        workoutSetCreateFormData.resetField('weight');
        workoutSetCreateFormData.resetField('reps');
        workoutSetCreateFormData.resetField('url');
        store.dispatch(resetCustomerWorkoutSetFormValue());
    };

    const createExercise = async () => {
        const convertedGroup = Object.values(ExerciseCreateRequestGroupEnum).find(element => element === getValues('group'));

        await exerciseManager.create({
            name: getValues('name'),
            group: convertedGroup,
            url: getValues('url'),
            data: {
                author: {
                    id: 0,
                    name: 'zambrinis',
                },
            },
        });
        await search();
        toast('Esercizio aggiunto con successo');
    };

    const handleSubmit = async () => {
        const isFormValid = await trigger();
        if (isFormValid) {
            await queueManager.queue(QueueKeyType.DEFAULT, createExercise());
            resetField('name');
            resetField('group');
            resetField('url');
        }
    };
    const { errors, register, trigger, getValues, control, setValue, resetField } = FormManager.getInstance().buildFormProxy<ExerciseFormData>(
        ExerciseFormData,
        handleSubmit,
        {
            name: exerciseFormValues.name,
            group: exerciseFormValues.group,
        },
        'onChange',
    );
    const [exerciseFormValuesState, setExerciseFormValuesState] = useState<ExerciseCreateUpdate>({ name: '', group: '' });

    const handleSelectGroupToCreate = (selectedGroup: SelectableExerciseGroup) => {
        store.dispatch(selectGroup({ selectedGroup }));
        setExerciseFormValuesState({ name: exerciseFormValuesState.name, group: selectedGroup.value });
        setValue('group', selectedGroup.value);
    };

    const handleStartCreate = () => {
        notificationManager.show({
            type: PopupType.Info,
            title: 'Nuovo esercizio',
            icon: 'bi-activity',
            children: (
                <div>
                    <div className='d-flex flex-column justify-content-between gap-3 bd-highlight mb-3 ps-4 '>
                        <div>
                            <TextField
                                type='text'
                                placeholder={'Nome esercizio'}
                                id='name'
                                fullWidth
                                {...register('name')}
                                error={errors.name}
                                errorMessage={errors.name && getMessageByFieldAndError('name', errors)}
                                onBlur={(e: React.FocusEvent<HTMLInputElement, Element>) => handleOnBlur(e.target.name, e.target.value)}
                            />
                        </div>
                        <div style={{ textAlign: 'left' }}>
                            <Select
                                styles={reactSelectStyles}
                                components={reactSelectComponents}
                                getValue={getValues('group') === '' ? null : muscleGroups.find(obj => obj.value === getValues('group'))}
                                id='group'
                                {...register('group')}
                                options={muscleGroups.sort((a, b) => b.label.localeCompare(a.label)).reverse()}
                                error={errors.group}
                                errorMessage={errors.group && getMessageByFieldAndError('group', errors)}
                                onChange={(choice: SelectableExerciseGroup) => handleSelectGroupToCreate(choice)}
                            />
                        </div>
                        <div>
                            <TextField
                                type='text'
                                placeholder={'Video URL (opzionale)'}
                                id='url'
                                fullWidth
                                {...register('url')}
                                error={errors.url}
                                errorMessage={errors.url && getMessageByFieldAndError('url', errors)}
                                onBlur={(e: React.FocusEvent<HTMLInputElement, Element>) => handleOnBlur(e.target.name, e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            ),
            ctas: {
                primary: {
                    cta: () => {
                        handleSubmit();
                        notificationManager.hide();
                        handleClearWorkoutSet();
                    },
                },
                close: {
                    cta: () => {
                        resetField('name');
                        resetField('group');
                        store.dispatch(resetExerciseCreate());
                    },
                },
            },
        });
    };

    const getWorkoutSummary = async () => {
        if (workoutItem != undefined) {
            const response = await dashboardManager.getWorkoutSummary(workoutItem.id!);
            store.dispatch(setWorkoutSummary({ response }));
        }
    };

    const [customerWorkoutSetCreateState, setCustomerWorkoutSetCreatUpdateState] = useState<CustomerWorkoutSetCreatUpdate>(setCreateUpdate);
    const [customerWorkoutSetUpdateState, setCustomerWorkoutSetUpdateState] = useState<CustomerWorkoutSetCreatUpdate>(setCreateUpdate);

    const [setsCounter, setSetsCounter] = useState<number>(0);

    const statPill = (label: string, value: string | number | undefined) =>
        value ? (
            <div
                className='d-flex justify-content-center gap-2 px-3 py-2 align-items-center text-center flex-shrink-0'
                style={{ backgroundColor: '#f5f5f5', border: '1px solid rgba(0,0,0,0.06)', borderRadius: '0.75rem' }}>
                <p className='m-0' style={{ color: '#888', fontSize: '0.8rem' }}>
                    {label}
                </p>
                <p className='m-0 fw-bold' style={{ color: '#333', fontSize: '0.8rem' }}>
                    {value}
                </p>
            </div>
        ) : null;

    return (
        <PageTransition className='mt-4 px-3 px-md-4'>
            {/* ── Page Header ──────────────────────────────────────────── */}
            <div
                className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 p-4 anim-slide-up'
                style={{
                    background: 'linear-gradient(135deg, #fff 0%, #fafafa 100%)',
                    borderRadius: 12,
                    border: '1px solid rgba(0,0,0,0.06)',
                }}>
                <div>
                    <div className='d-flex align-items-center gap-2 mb-1'>
                        <i className='bi bi-list-check' style={{ fontSize: '1.4rem', color: '#ff4949' }}></i>
                        <h4 className='mb-0 fw-bold' style={{ color: '#333' }}>
                            {workoutItem.title}
                        </h4>
                    </div>
                    <p className='mb-0 mt-1' style={{ color: '#666', fontSize: '0.9rem' }}>
                        {sets.length > 0 ? (
                            <>
                                <span className='badge rounded-pill me-2' style={{ backgroundColor: '#ff4949', color: '#fff', fontSize: '0.8rem' }}>
                                    {sets.length}
                                </span>
                                serie inserite
                            </>
                        ) : (
                            'Aggiungi serie al workout'
                        )}
                    </p>
                </div>
                <div className='mt-3 mt-md-0'>
                    <Button
                        identifier='Nuovo esercizio'
                        icon={<i className='bi bi-plus-lg' style={{ fontSize: '1rem', color: 'white' }}></i>}
                        onClick={handleStartCreate}
                        variant='primary'
                    />
                </div>
            </div>

            {/* ── Add Set Panel ─────────────────────────────────────────── */}
            <div
                className='mb-4 p-3 anim-slide-up'
                style={{
                    backgroundColor: '#f9f9f9',
                    borderRadius: 10,
                    border: '1px solid rgba(0,0,0,0.06)',
                    borderLeft: '3px solid #ff4949',
                }}>
                <div className='d-flex align-items-center gap-2 mb-3'>
                    <i className='bi bi-plus-circle-fill' style={{ fontSize: '0.95rem', color: '#ff4949' }}></i>
                    <span className='fw-semibold' style={{ color: '#333', fontSize: '0.9rem' }}>
                        Nuova serie
                    </span>
                </div>
                {/* Row 1: Selects */}
                <div className='row g-3 mb-3'>
                    <div className='col-12 col-md-6'>
                        <Select
                            styles={{
                                ...reactSelectStyles,
                                menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                            }}
                            menuPortalTarget={document.body}
                            components={reactSelectComponents}
                            options={muscleGroups.sort((a, b) => b.label.localeCompare(a.label)).reverse()}
                            placeholder='Seleziona un gruppo...'
                            onChange={(choice: SelectableExerciseGroup) => {
                                workoutSetCreateFormData.setValue('exerciseGroup.value', choice);
                                handleSelectGroup(choice);
                            }}
                            value={customerWorkoutSetCreateState.exerciseGroup === '' ? null : muscleGroups.find(obj => obj.value === customerWorkoutSetCreateState.exerciseGroup)}
                        />
                    </div>
                    <div className='col-12 col-md-6'>
                        <Select
                            styles={{
                                ...reactSelectStyles,
                                menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                            }}
                            menuPortalTarget={document.body}
                            components={reactSelectComponents}
                            options={selectableExercises}
                            placeholder='Seleziona un esercizio...'
                            onChange={(choice: SelectableExerciseGroup) => {
                                handleSelectExercise(choice);
                            }}
                            value={
                                customerWorkoutSetCreateState.exerciseName === '' ? null : selectableExercises.find(obj => obj.value === customerWorkoutSetCreateState.exerciseName)
                            }
                        />
                    </div>
                </div>
                {/* Row 2: Inputs + Buttons */}
                <div className='d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-3'>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <TextField
                            type='number'
                            value={setsCounter}
                            id='sets'
                            placeholder='Sets'
                            onChange={e => {
                                setSetsCounter(Number(e.target.value));
                                console.log(setsCounter);
                            }}
                        />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <TextField
                            type='text'
                            placeholder='Reps'
                            fullWidth
                            id='reps'
                            {...workoutSetCreateFormData.register('reps')}
                            error={workoutSetCreateFormData.errors.reps}
                            errorMessage={workoutSetCreateFormData.errors.reps && 'Campo obbligatorio'}
                            onBlur={e => handleOnBlur(e.target.name, e.target.value)}
                        />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <TextField
                            type='text'
                            placeholder='Weight'
                            fullWidth
                            id='weight'
                            {...workoutSetCreateFormData.register('weight')}
                            error={workoutSetCreateFormData.errors.weight}
                            errorMessage={workoutSetCreateFormData.errors.weight && 'Campo obbligatorio'}
                            onBlur={e => handleOnBlur(e.target.name, e.target.value)}
                        />
                    </div>
                    <div className='d-flex gap-2'>
                        <Button
                            identifier='Aggiungi'
                            icon={<i className='bi bi-plus-lg' style={{ fontSize: '0.9rem', color: 'white' }}></i>}
                            onClick={() => handleCreateWorkoutSet()}
                            variant='primary'
                        />
                        <Button
                            identifier='Pulisci'
                            icon={<i className='bi bi-x-circle' style={{ fontSize: '0.9rem' }}></i>}
                            onClick={() => handleClearWorkoutSet()}
                            variant='secondary'
                        />
                    </div>
                </div>
            </div>

            {/* ── Summary Pills ────────────────────────────────────────── */}
            {workoutSummaryItem && workoutSummaryItem.muscleGroupSets !== undefined && workoutSummaryItem.muscleGroupSets.length > 0 && (
                <>
                    <div className='d-flex flex-wrap gap-2 mb-3 anim-slide-up'>
                        {statPill('Total', workoutSummaryItem.total)}
                        {workoutSummaryItem.muscleGroupSets.map((summaryItem: DashboardSessionSummaryMuscleGroupSet, i: number) => (
                            <React.Fragment key={i}>{statPill(summaryItem.exerciseGroup!, summaryItem.sets)}</React.Fragment>
                        ))}
                    </div>
                    {workoutSummaryItem.exerciseSets && workoutSummaryItem.exerciseSets.length > 0 && (
                        <div className='d-flex flex-wrap gap-2 mb-4 anim-slide-up'>
                            {workoutSummaryItem.exerciseSets.map((summaryExerciseItem: DashboardSessionSummaryExercise, i: number) => (
                                <React.Fragment key={i}>{statPill(summaryExerciseItem.exerciseName!, summaryExerciseItem.sets)}</React.Fragment>
                            ))}
                        </div>
                    )}
                </>
            )}

            {/* ── Exercise Set List ────────────────────────────────────── */}
            {sets.length > 0 && (
                <div className='d-flex flex-column gap-4 mb-4'>
                    {Object.entries(
                        sets.reduce((acc, set) => {
                            if (!acc[set.exerciseName!]) {
                                acc[set.exerciseName!] = [];
                            }
                            acc[set.exerciseName!].push(set);
                            return acc;
                        }, {} as Record<string, SessionSet[]>),
                    ).map(([exerciseName, seets], groupIndex) => {
                        const exerciseSummary = dashboardSessionSummaryExercise?.find(sum => sum.name == exerciseName);

                        return (
                            <div
                                key={exerciseName}
                                className='app-card anim-stagger'
                                style={
                                    {
                                        '--anim-index': groupIndex,
                                        borderLeft: '3px solid #ff4949',
                                        padding: 0,
                                        overflow: 'hidden',
                                    } as React.CSSProperties
                                }>
                                <div className='p-3'>
                                    {/* Exercise group header */}
                                    <div className='d-flex align-items-center gap-2 mb-2'>
                                        <i className='bi bi-activity' style={{ fontSize: '1rem', color: '#ff4949' }}></i>
                                        <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>
                                            {exerciseName}
                                        </h6>
                                        <span className='badge rounded-pill' style={{ backgroundColor: '#f2f2f2', color: '#666', fontSize: '0.75rem' }}>
                                            {seets.length}
                                        </span>
                                    </div>

                                    {/* Exercise stats pills */}
                                    {exerciseSummary && (
                                        <div className='d-flex flex-wrap gap-2 mb-3'>
                                            {statPill('AVG weight', exerciseSummary.averageWeight)}
                                            {statPill('MAX weight', exerciseSummary.maxWeight)}
                                            {statPill('MIN weight', exerciseSummary.minWeight)}
                                            {statPill('AVG reps', exerciseSummary.averageReps)}
                                            {statPill('MAX reps', exerciseSummary.maxReps)}
                                            {statPill('MIN reps', exerciseSummary.minReps)}
                                            {statPill('1RM', exerciseSummary.oneRm)}
                                            {statPill('95%', exerciseSummary.oneRm95)}
                                            {statPill('90%', exerciseSummary.oneRm90)}
                                            {statPill('85%', exerciseSummary.oneRm85)}
                                            {statPill('80%', exerciseSummary.oneRm80)}
                                            {statPill('75%', exerciseSummary.oneRm75)}
                                            {statPill('70%', exerciseSummary.oneRm70)}
                                        </div>
                                    )}

                                    {/* Last session info */}
                                    {exerciseSummary?.lastSessionDetails && (
                                        <div className='d-flex flex-wrap gap-2 mb-3'>
                                            <div
                                                className='d-flex justify-content-center gap-2 px-3 py-2 align-items-center text-center flex-shrink-0'
                                                style={{ backgroundColor: '#f5f5f5', border: '1px solid rgba(0,0,0,0.06)', borderRadius: '0.75rem' }}>
                                                <p className='m-0' style={{ color: '#888', fontSize: '0.8rem' }}>
                                                    Last session
                                                </p>
                                                <p className='m-0 fw-bold' style={{ color: '#333', fontSize: '0.8rem' }}>
                                                    {exerciseSummary.lastSessionDetails.date}
                                                </p>
                                                <p className='m-0 fw-bold' style={{ color: '#333', fontSize: '0.8rem' }}>
                                                    {exerciseSummary.lastSessionDetails.weight}
                                                </p>
                                                <p className='m-0 fw-bold' style={{ color: '#333', fontSize: '0.8rem' }}>
                                                    {exerciseSummary.lastSessionDetails.reps}
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    {/* Set rows */}
                                    <div className='d-flex flex-column gap-2'>
                                        {seets.map((currentSet: SessionSet) => (
                                            <div key={currentSet.uuid}>
                                                {currentSet.id !== setItem.id ? (
                                                    <div
                                                        className='d-flex flex-row align-items-center justify-content-between p-2'
                                                        style={{ backgroundColor: '#fafafa', borderRadius: 8, border: '1px solid rgba(0,0,0,0.04)' }}>
                                                        <div className='d-flex gap-4'>
                                                            <span style={{ color: '#666', fontSize: '0.85rem' }}>{currentSet.exerciseName}</span>
                                                            <span className='fw-semibold' style={{ fontSize: '0.85rem' }}>
                                                                {currentSet.weight} kg
                                                            </span>
                                                            <span className='fw-semibold' style={{ fontSize: '0.85rem' }}>
                                                                {currentSet.reps} reps
                                                            </span>
                                                        </div>
                                                        <div className='d-flex gap-2'>
                                                            <Button identifier='Duplica' onClick={() => handleDuplicate(currentSet)} variant='primary' />
                                                            <Button identifier='Modifica' onClick={() => handleStartEdit(currentSet)} variant='primary' />
                                                            <Button identifier='Elimina' onClick={() => handleDelete(currentSet.uuid!)} variant='secondary' />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className='row align-items-center p-2 g-2'
                                                        style={{ backgroundColor: '#fff8f0', borderRadius: 8, border: '1px solid #ffe0b2' }}>
                                                        <div className='col-auto'>
                                                            <span style={{ color: '#666', fontSize: '0.85rem' }}>{setCreateUpdate.exerciseName}</span>
                                                        </div>
                                                        <div className='col-6 col-md-2'>
                                                            <TextField
                                                                type='text'
                                                                placeholder='Weight'
                                                                fullWidth
                                                                id='editWeight'
                                                                {...workoutSetCreateFormData.register('editWeight')}
                                                                error={workoutSetCreateFormData.errors.weight}
                                                                errorMessage={
                                                                    workoutSetCreateFormData.errors.weight && getMessageByFieldAndError('editWeight', 'Campo obbligatorio')
                                                                }
                                                                onBlur={(e: React.FocusEvent<HTMLInputElement, Element>) => handleOnBlur(e.target.name, e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='col-6 col-md-2'>
                                                            <TextField
                                                                type='text'
                                                                placeholder='Reps'
                                                                fullWidth
                                                                id='editReps'
                                                                {...workoutSetCreateFormData.register('editReps')}
                                                                error={workoutSetCreateFormData.errors.reps}
                                                                errorMessage={workoutSetCreateFormData.errors.reps && getMessageByFieldAndError('editReps', 'Campo obbligatorio')}
                                                                onBlur={(e: React.FocusEvent<HTMLInputElement, Element>) => handleOnBlur(e.target.name, e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='col-auto d-flex gap-2'>
                                                            <Button identifier='Salva' onClick={() => handleSaveUpdate(currentSet)} variant='primary' />
                                                            <Button identifier='Annulla' onClick={() => handleCancelUpdate()} variant='secondary' />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </PageTransition>
    );
};
